import { EmployeesSortFields, SortOrder } from "@server/models.ts";
import { createFileRoute } from "@tanstack/react-router";
import z from "zod";

export const RouteSearchParams = z.object({
  page: z.coerce.number().min(0).optional().default(0),
  search: z.string().optional().default(""),
  sortBy: EmployeesSortFields.optional().default("name"),
  sortOrder: SortOrder.optional().default("asc"),
});
export type RouteSearchParams = z.infer<typeof RouteSearchParams>;

export const Route = createFileRoute("/employees/")({
  validateSearch: RouteSearchParams,
});
